import React, {useContext} from 'react';
import {PropTypes} from 'prop-types';

import {CurrencyMenuItem} from '@homeaway/react-currency-switcher';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {TrackingContext} from '@homeaway/react-event-tracking';

import {namedEvents, linkLocations} from '../../../utils/edap';

function CurrencyMenuItemsWrapper({
    currencyList,
    handleShowAllCurrenciesClick,
    isTopCurrenciesView,
    onCurrencySelectorChange,
    selectedCurrency,
    translations: {showAllCurrenciesText}
}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);

    function triggerCurrencySelectionEvent(currencyCode) {
        if (isTopCurrenciesView) {
            context.trigger(namedEvents.CURRENCY_SELECTED, {
                action_location: linkLocations.SIDEBAR_TOP_CURRENCY_LIST,
                displaycurrency: selectedCurrency,
                selected_display_currency: currencyCode
            });
            context.trigger(namedEvents.CURRENCY_UPDATED, {
                action_location: linkLocations.SIDEBAR_TOP_CURRENCY_LIST,
                displaycurrency: selectedCurrency,
                selected_display_currency: currencyCode
            });
        } else {
            context.trigger(namedEvents.CURRENCY_SELECTED, {
                action_location: linkLocations.SIDEBAR_ALL_CURRENCY_LIST,
                displaycurrency: selectedCurrency,
                selected_display_currency: currencyCode
            });
            context.trigger(namedEvents.CURRENCY_UPDATED, {
                action_location: linkLocations.SIDEBAR_ALL_CURRENCY_LIST,
                displaycurrency: selectedCurrency,
                selected_display_currency: currencyCode
            });
        }
    }

    function handleCurrencySelectorChange(e) {
        onCurrencySelectorChange(e.currentTarget.dataset.currencyCode);
    }

    const renderItem = (item) => {
        return (
            <a
                className={selectedCurrency === item.code ? 'site-header-tray__menu-item-link site-header-tray__currency-item-selected' : 'site-header-tray__menu-item-link'}
                key={item.code}
                data-currency-code={item.code}
                onClick={handleCurrencySelectorChange}
                onKeyPress={handleCurrencySelectorChange}
                role={'menuitem'}
            >
                <CurrencyMenuItem
                    currencyCode={item.code}
                    currencySymbol={item.symbol}
                    currencyName={item.name}
                    isActive={selectedCurrency === item.code}
                    eventTrigger={triggerCurrencySelectionEvent}
                />
            </a>
        );
    };

    return (
        <div className="site-header-tray__menu site-header-tray__drawer">
            <div className="site-header-tray__items">
                {currencyList.map(renderItem)}
            </div>
            {isTopCurrenciesView &&
                <div
                    className="site-header-tray__items"
                    onClick={handleShowAllCurrenciesClick}
                    role={'menuitem'}
                >
                    <a className="site-header-tray__menu-item-link">
                        <span className="site-header-tray__menu-item-link--all-currencies-link">
                            {showAllCurrenciesText}
                            <SVGIcon className="text-muted" inline markup={CHEVRON_RIGHT__16} />
                        </span>
                    </a>
                </div>
            }
        </div>
    );
}

CurrencyMenuItemsWrapper.propTypes = {
    currencyList: PropTypes.arrayOf(PropTypes.shape({})),
    handleShowAllCurrenciesClick: PropTypes.func,
    isTopCurrenciesView: PropTypes.bool,
    onCurrencySelectorChange: PropTypes.func,
    selectedCurrency: PropTypes.string,
};

export {CurrencyMenuItemsWrapper};
